import GET_ORDERS from "../graphql/allOrdersForUser.gql";
import GET_DOCUMENT from "../graphql/editDocument.gql";
import { apolloClient } from './apollo'


export function getOrders(serviceman) {
    return apolloClient.mutate({
        mutation: GET_ORDERS,
        variables: {
            serviceman: serviceman
        }
    })
}
export function getOrderInformation(type= '', docEntry = '', documentOwner = '',cardCode='') {
    return apolloClient.mutate({
        fetchPolicy: "no-cache",
        mutation: GET_DOCUMENT,
        variables: {
            type: (type) ? type : "",
            docEntry: (docEntry) ? docEntry : "",
            documentOwner: (documentOwner) ? documentOwner : "",
            cardCode: (cardCode) ? cardCode : "",
            
        },
        update: (cache, { data: { documentFormFilter } }) => {
            console.log(documentFormFilter);
        },
    })
}
